// All runtime config comes from VITE_* env vars (set per stage at build time).
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ?? "https://dev.api.smartsafiri.tz/api/v1";

// Public trip-tracking SPA base — used to deep-link a trip's share page.
export const TRACK_BASE_URL =
  import.meta.env.VITE_TRACK_BASE_URL ?? "https://track-dev.smartsafiri.tz";

// Pusher (realtime) — for the live SOS alert + live trip tracking in admin.
export const PUSHER_KEY = import.meta.env.VITE_PUSHER_KEY ?? "";
export const PUSHER_CLUSTER = import.meta.env.VITE_PUSHER_CLUSTER ?? "ap2";

// Safiri AI Agent (bot service — separate FastAPI process)
export const BOT_BASE_URL =
  import.meta.env.VITE_BOT_BASE_URL ?? "http://localhost:8000";

// Google Maps browser key for the live operations map. Optional: without it the
// live board still works as lists, just without the map.
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? "";
